module.exports = __webpack_public_path__ + "img/dzxx.7fb6216.png";